<template>
  <section class="Fiche__title text-ttgros">
    <span>
      {{ p.name | mo }}<br /><span class="Fiche__subtitle"
        ><span v-if="p.program_scalene">{{ p.program_scalene | mo }}</span>
      </span>
    </span>
  </section>
</template>

<script>
export default {
  name: "titre-fiche",
  props: {
    p: {}
  }
};
</script>
